/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBarberShiftAppointment } from "../../entities/models/BarberShiftAppointment";
import { z } from "zod/v4";

export const modelsBarberShiftAppointmentSchema = z.object({
    "client_name": z.optional(z.string()),
"created_at": z.optional(z.string()),
"id": z.optional(z.int()),
"position": z.optional(z.int()),
"scheduled_start_time": z.optional(z.string()),
"service_id": z.optional(z.int()),
"service_name": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsBarberShiftAppointment>